<template>
    <!-- 单选框二次封装
        @author: liuguisheng
        @date: 2019-9-13
    -->
  <preview-form-item v-if="isDisplay && showRule!=='render'"
                     :labelText="labelName"
                     :labelWidth="labelWidth"
                     :labelPosition="labelPosition"
                     :textAlign="labelTextPosition"
                     :formType="formType"
                     :variableName="model"
                     :rules="validatorRule"
                     :paddingLeft="paddingLeft">
    <div class="form-item_input">
      <el-input type='text'
                v-model="currentModel"
                :placeholder="placeholder"
                :clearable="isClearable"
                :disabled="isDisabled"
                :limit-length="textLength"
                :style="{ width }">
      </el-input>
      <p v-if="validator.isMoney && currentModel" :style="{width: width,opacity: .6}">{{toBigCase}}</p>
    </div>
  </preview-form-item>
</template>
<script>
/** 混入方法 ::: 
 *  @mixin mixPreviewItemTemplateChild 预览表单项子级混入
 */
import { mixPreviewItemTemplateChild } from "@/mixins/preview_item/mix_preview_item_template_child.js";
import { moneyToCapitals } from "@/utils/unit_format.js"
export default {
  mixins: [ mixPreviewItemTemplateChild ],
  computed: {
    /**
     * @name 小写转大写需求添加
     * @author liuguisheng
     * @version 2020-05-22 星期五
     */
    
    toBigCase () {
      let { isMoney } = this.validator;
      return isMoney ? moneyToCapitals(this.currentModel) : this.currentModel;

    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/preview_item/PreviewItemInput.vue